import React from 'react';
import { ReactComponent as GroupIcon } from '../../../assets/icons/group-icon.svg';
import { ReactComponent as ChevronRight } from '../../../assets/icons/chevron-right.svg';

interface GroupEdit {
  name: string;
  description: string;
}

export type { GroupEdit };

interface AssetGroupEditorProps {
  groupEdit: GroupEdit;
  onGroupEditChange: (edit: GroupEdit) => void;
  isGroupExpanded: boolean;
  onToggleGroupExpanded: () => void;
  isSettled: boolean;
  disabled: boolean;
}

const AssetGroupEditor: React.FC<AssetGroupEditorProps> = ({
  groupEdit,
  onGroupEditChange,
  isGroupExpanded,
  onToggleGroupExpanded,
  isSettled,
  disabled,
}) => (
  <div className="border-b border-eai-border pb-4">
    <button
      type="button"
      disabled={disabled || isSettled}
      onClick={() => !isSettled && onToggleGroupExpanded()}
      className="flex items-center gap-1 mb-2 disabled:cursor-default"
    >
      <p className="text-xs font-semibold text-eai-ink-faint uppercase tracking-wide">Asset Group</p>
      {!isSettled && (
        <ChevronRight className={`w-3 h-3 flex-shrink-0 text-eai-ink-faint transition-transform ${isGroupExpanded ? 'rotate-90' : ''}`} />
      )}
    </button>

    <div className="flex items-center gap-2">
      <GroupIcon className="w-5 h-5 flex-shrink-0 text-eai-ink-faint" />
      <p className="text-sm font-semibold text-eai-ink">{groupEdit.name}</p>
    </div>

    {isGroupExpanded && !isSettled && (
      <div className="mt-3 space-y-4">
        <div>
          <label className="block text-xs text-eai-ink-subtle font-medium mb-1">Name</label>
          <input
            type="text"
            value={groupEdit.name}
            onChange={(e) => onGroupEditChange({ ...groupEdit, name: e.target.value })}
            className="eai-input"
          />
        </div>
        <div>
          <label className="block text-xs text-eai-ink-subtle font-medium mb-2">Group Image</label>
          <div className="flex items-center gap-3">
            <GroupIcon className="w-10 h-10 flex-shrink-0 text-eai-ink-ghost" />
            <span className="text-xs text-eai-ink-faint bg-eai-surface-hover px-2 py-1 rounded-full">Coming Soon</span>
          </div>
        </div>
        <div>
          <label className="block text-xs text-eai-ink-subtle font-medium mb-1">Description</label>
          <textarea
            value={groupEdit.description}
            onChange={(e) => onGroupEditChange({ ...groupEdit, description: e.target.value })}
            rows={2}
            className="w-full border border-eai-border-hover rounded-md px-2 py-1.5 text-sm focus:outline-none focus:ring-1 focus:ring-eai-focus resize-none"
            placeholder="Add a description..."
          />
        </div>
      </div>
    )}
  </div>
);

export default AssetGroupEditor;
